
import WalletAdd from "../../../assets/filled/WalletAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WalletAddIcon({ className, dataTestid = "WalletAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <WalletAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
